import React from 'react';

const ConfigurationPlaceholder = () => {
  return (
    <div className="tooldialog__wrapper">
      <ul className="generic-list">
        {Array.from({ length: 3 }, (_, i) => (
          <li key={`result-item__placeholder${i}`} className="result-item__placeholder">
            <div className="text__placeholder shimmer" />
            <div className="text__placeholder--small shimmer" />
            <div className="text__placeholder--small shimmer" />
            <div className="text__placeholder--small shimmer" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ConfigurationPlaceholder;
